module.exports = __webpack_public_path__ + "img/arrow-up-triangle-square.a2fc8156.svg";